<template>
  <div class="resetPass column align-center justify-center">
    <div class="background" v-if="background"></div>
    <div class="box">
      <div class="box-container">
        <div class="align-center column">
          <img src="../assets/img/logo-client-icon.png" alt="NS SUPPORT" width="200" />
          <div class="font-15 instructions">
            Preencha seus dados para definir a senha de sua conta:
          </div>
        </div>

        <form onsubmit="return false;" @submit="reset()">
          <div class="font-12 column grid-12 field">
            <label for="email">Seu e-mail</label>
            <div class="email">{{ data.email }}</div>
          </div>
          <div class="font-12 column grid-12 field">
            <label>Senha</label>
            <div class="row">
              <input id="pass" v-model="data.nova_senha" placeholder="Senha"
                :type="isPwd.nova_senha ? 'password' : 'text'" required />
              <i class="see fa" @click="isPwd.nova_senha = !isPwd.nova_senha"
                :class="isPwd.nova_senha ? 'fa-eye' : 'fa-eye-slash'"></i>
            </div>
          </div>
          <div class="font-12 column grid-12 field">
            <label for>Confirmar Senha</label>
            <div class="row">
              <input id="pass" v-model="data.confirma_nova_senha" placeholder="Confirmar Senha"
                :type="isPwd.confirma_nova_senha ? 'password' : 'text'" required />
              <i class="see fa" @click="isPwd.confirma_nova_senha = !isPwd.confirma_nova_senha"
                :class="isPwd.confirma_nova_senha ? 'fa-eye' : 'fa-eye-slash'"></i>
            </div>
          </div>
          <div class="row control grid-12 justify-center align-center">
            <Button id="submit" layout="green-m" :loader="loader" type="submit" :disabled="loader">DEFINIR SENHA</Button>
          </div>
        </form>
      </div>
    </div>
    <Status />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Api from "@/conf/Api";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";

export default {
  name: "ResetPass",
  components: {
    Button,
    Status,
  },
  data() {
    return {
      api: Api,
      isPwd: {
        nova_senha: true,
        confirma_nova_senha: true,
      },
      data: {
        email: "",
        nova_senha: "",
        confirma_nova_senha: "",
        token: "",
      },
      loader: false,
      background: true,
    };
  },
  methods: {
    ...mapActions("user", ["RESET_PASS", "SET_LOGIN"]),
    reset() {
      this.loader = true;

      this.RESET_PASS(this.data)
        .then(() => {
          if (this.data.nova_senha === this.data.confirma_nova_senha)
            this.SET_LOGIN({
              login: this.data.email,
              senha: this.data.nova_senha,
            })
              .then(() => this.loader = false)
              .catch(() => this.loader = false)
        })
        .catch(() => this.loader = false);
    },
  },
  beforeMount() {
    this.data.token = this.$route.params.token;
    this.data.email = this.$route.params.email;
    this.background = window.innerWidth < 849 ? false : true;
  },
  computed: {
    ...mapGetters("general", ["status"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.resetPass {
  height: 100vh;

  .background {
    background-image: linear-gradient(to top, $client-1, $client-2);
    height: 100vh;
    position: absolute;
    width: 100%;
    z-index: -1;
  }

  .box {
    width: 600px;
    /* background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 15px #222; */

    @media (max-width: $small) {
      width: 100%;
      padding-top: 10%;
      height: 100vh;
    }

    @media (min-width: $small) {
      min-width: 500px;
      min-height: 493px;
      border-radius: 10px;
    }

    &-container {
      padding: 40px 47px;
      padding-bottom: 23px;
    }
  }

  .instructions {
    margin-top: 30px;
    margin-bottom: 27px;
  }

  .email {
    font-size: 15px;
    font-weight: bold;
    color: white;
    padding: 5px;
  }

  input {
    background: #fafafa 0% 0% no-repeat padding-box;
    border: 1px solid $white-6;
    border-radius: 5px;
    opacity: 1;
    height: 47px;
    padding: 0px 5%;
    margin-top: 7px;
    color: $gray-2;
    width: 90%;

    &:focus {
      background: $green-3;
      border-bottom: 5px solid $green-2;
    }
  }

  .field {
    margin-top: 19px;
  }

  .see {
    font-size: 26px;
    position: relative;
    color: $gray-2;
    margin-left: -37px;
    margin-top: 20px;
    cursor: pointer;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }

  .control {
    margin-top: 40px;
  }

  .create {
    border-top: 1px solid $white-6;
    margin-top: 35px;
    padding-top: 25px;
    font-size: 13px;
    text-align: center;
    color: $black-2;
  }
}
</style>